import { Skeleton } from '@mui/material';

import { Field, Input, InputBox, Label, LoadingBox } from './styles';

export default function SkeletonInput() {
  return (
    <LoadingBox>
      <Label>
        <Skeleton variant="text" width={50} />
      </Label>
      <InputBox>
        <Input>
          <Skeleton />
        </Input>
        <Field />
      </InputBox>
    </LoadingBox>
  );
}
